<template>
  <v-card>
    <div class="text-xs-right">
      <v-btn @click="$emit('close')" small icon>
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <div class="pt-4">
      <div>
        <div class="px-4 pb-3">
          <div class="titletero">ชื่อชุดคำถาม</div>
          <div
            class="form-control"
            :class="{ 'has-error': errors.has('intentName') }"
            style="max-width: 600px"
          >
            <input
              v-model="input.question"
              :data-vv-as="'ชื่อชุดคำถาม'"
              name="intentName"
              placeholder="กรอกชื่อชุดคำถาม"
              type="text"
              v-validate="
                'required|excludednew:{default},{welcome}' +
                (excludedNameFilltered ? ',' + excludedNameFilltered : '')
              "
            />
            <span class="text-error" v-if="errors.has('intentName')">{{
              errors.first('intentName')
            }}</span>
          </div>
          <div class="mb-3">
            <div class="titletero mt-2">คีย์เวิร์ด</div>
            <tags
              v-model="tag"
              :tags="tags"
              @tags-changed="(newTags) => (tags = newTags)"
              :max="999"
              @before-adding-tag="checkTag"
              :btnText="$t('Add')"
            ></tags>
            <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <span class="text-error" v-if="errorTag.length > 0">
                <template v-if="errorTag.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="errorTag.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="errorTag.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </div>
          </div>
          <div>
            <v-layout>
              <v-flex class="pr-1">
                <div class="form-control">
                  <div class="caption">{{ $t('Turn-on Time') }}</div>
                  <v-layout wrap>
                    <v-flex
                      xs6
                      class="form-control"
                      :class="{ 'has-error': errors.has('startdate') }"
                    >
                      <v-menu
                        ref="openStartDate"
                        v-model="openStartDate"
                        :close-on-content-click="false"
                        full-width
                        max-width="290px"
                        color="primary"
                      >
                        <template v-slot:activator="{ on }">
                          <input
                            type="text"
                            class="form-control browser-default"
                            :placeholder="$t('Date')"
                            readonly
                            v-model="startDate"
                            v-on="on"
                            clearable
                          />
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="startDate"
                          @input="
                            openStartDate = false
                            endDate = ''
                            endTime = ''
                          "
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs4 class="pl-1">
                      <v-menu
                        ref="openStartTime"
                        v-model="openStartTime"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="startTime"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                        :disabled="startDate == null"
                      >
                        <template v-slot:activator="{ on }">
                          <input
                            type="text"
                            class="form-control browser-default"
                            :placeholder="$t('Time')"
                            readonly
                            v-model="startTime"
                            v-on="on"
                            :disabled="startDate == null"
                          />
                        </template>
                        <v-time-picker
                          :max="maxStartTime"
                          v-if="openStartTime"
                          v-model="startTime"
                          full-width
                          @click:minute="$refs.openStartTime.save(startTime)"
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
              <v-flex class="pl-1">
                <div class="form-control">
                  <div class="caption">{{ $t('Turn-off Time') }}</div>
                  <v-layout wrap>
                    <v-flex
                      class="form-control"
                      xs6
                      :class="{ 'has-error': errors.has('enddate') }"
                    >
                      <v-menu
                        ref="openEndDate"
                        v-model="openEndDate"
                        :close-on-content-click="false"
                        full-width
                        max-width="290px"
                        color="primary"
                      >
                        <template v-slot:activator="{ on }">
                          <input
                            type="text"
                            class="form-control browser-default"
                            :placeholder="$t('Date')"
                            readonly
                            v-model="endDate"
                            v-on="on"
                            clearable
                          />
                        </template>
                        <v-date-picker
                          :allowed-dates="allowedDates"
                          color="primary"
                          v-model="endDate"
                          @input="openEndDate = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs4 class="pl-1">
                      <v-menu
                        ref="openEndTime"
                        v-model="openEndTime"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="endTime"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                        :disabled="endDate == null"
                      >
                        <template v-slot:activator="{ on }">
                          <input
                            type="text"
                            class="form-control browser-default"
                            :placeholder="$t('Time')"
                            readonly
                            v-model="endTime"
                            v-on="on"
                            :disabled="endDate == null"
                          />
                        </template>
                        <v-time-picker
                          :min="minEndTime"
                          :allowed-hours="allowedHours"
                          v-if="openEndTime"
                          v-model="endTime"
                          full-width
                          @click:minute="$refs.openEndTime.save(endTime)"
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <v-divider></v-divider>
        <div>
          <v-layout row wrap>
            <v-flex class="pb-4 px-3 pt-1" xs12 sm6 style="border-right: 1px solid #eee">
              <div>
                <div class="titletero mt-2 mb-4">คำถาม</div>
                <intent-group
                  :maxIntent="10"
                  v-model="question_messages"
                  :hasAlternative="false"
                  :isWelcome="true"
                ></intent-group>
              </div>
            </v-flex>
            <v-flex class="pb-4 px-3 pt-1" xs12 sm6 style="border-right: 1px solid #eee">
              <div>
                <div class="titletero mt-2 mb-4">คำตอบ</div>
                <v-fade-transition group>
                  <div
                    v-for="(item, k) in answerinput"
                    :key="k"
                    class="form-control"
                    :class="{
                      'has-error': errors.has(
                        `ตัวเลือก ${String.fromCharCode(97 + k).toUpperCase()}`
                      )
                    }"
                    style="position: relative"
                  >
                    <input
                      maxlength="20"
                      :name="`ตัวเลือก ${String.fromCharCode(97 + k).toUpperCase()}`"
                      :data-vv-as="`คำตอบ`"
                      v-validate="'required'"
                      style="padding-right: 29px"
                      v-model="answerinput[k]"
                      :placeholder="`ตัวเลือก ${String.fromCharCode(97 + k).toUpperCase()}`"
                      type="text"
                    />
                    <span
                      v-if="answerinput.length > 1"
                      style="
                        position: absolute;
                        right: -8px;
                        top: 2px;
                        border-left: 1px solid #ececec;
                      "
                      ><v-btn @click="answerinput.splice(k, 1)" small icon>
                        <v-icon color="grey" small>close</v-icon>
                      </v-btn></span
                    >
                    <span
                      class="text-error"
                      v-if="errors.has(`ตัวเลือก ${String.fromCharCode(97 + k).toUpperCase()}`)"
                      >{{
                        errors.first(`ตัวเลือก ${String.fromCharCode(97 + k).toUpperCase()}`)
                      }}</span
                    >
                  </div>
                </v-fade-transition>
                <v-btn
                  :disabled="checkMaxAnswer"
                  @click="addAnswerinput"
                  block
                  outline
                  color="primary"
                >
                  <span v-if="checkMaxAnswer">สามารถสร้างได้ไม่เกิน 10 ตัวเลือก</span>
                  <em v-else class="fas fa-plus" />
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-divider></v-divider>
              <div class="pa-3">
                <div class="titletero mt-2 mb-4">ข้อความตอบกลับ</div>
                <intent-group
                  v-model="answer_messages"
                  :hasAlternative="false"
                  :isWelcome="true"
                ></intent-group>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="text-xs-center pb-3">
        <div v-if="errorMessage" style="color: red">{{ errorMessage }}</div>
        <v-btn @click="$emit('close')" color="grey" outline>{{ $t('cancel') }}</v-btn>
        <v-btn @click="saveData" :loading="saveloading" color="primary" depressed>{{
          $t('Save')
        }}</v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import Tags from '@/components/elements/Tags'
import specialtext from '@/components/elements/specialtext'
import IntentGroup from '@/components/view/intent/IntentGroup'
import { mapGetters } from 'vuex'
import moment from 'moment'
import api from '@/api'

const dict = {
  en: {
    custom: {
      intentName: {
        excluded: 'Duplicate Conversation Name',
        excludednew: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      intentName: {
        excluded: 'ชื่อบทสนทนาซ้ำ',
        excludednew: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      intentName: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ',
        excludednew: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}

export default {
  props: ['value', 'inputvalue', 'type', 'excludedName'],
  data: function () {
    return {
      errorTag: [],
      tempname: '',
      id_question: '',
      id_answer: '',
      id_comment: '',
      saveloading: false,
      openStartDate: false,
      openStartTime: false,
      openEndDate: false,
      openEndTime: false,
      startDate: moment().format('YYYY-MM-DD'),
      startTime: '16:50',
      endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      endTime: '13:00',
      answerinput: ['', '', ''],
      question_messages: [[]],
      answer_messages: [[]],
      showAdvanced: false,
      result: '',
      tag: '',
      tags: [{ text: 'โหวต' }, { text: 'vote' }],
      input: {
        question: ''
      },
      errorMessage: '',
      userstatus: 'Vote',
      usertags: 'Vote'
    }
  },
  components: {
    Tags,
    IntentGroup,
    specialtext
  },
  computed: {
    maxStartTime() {
      if (this.endTime && this.startDate == this.endDate) {
        return this.endTime
      } else {
        return ''
      }
    },
    minEndTime() {
      if (this.startTime && this.startDate == this.endDate) {
        return this.startTime
      } else {
        return ''
      }
    },
    excludedNameFilltered() {
      return this.excludedName.filter((el) => el != this.tempname)
    },
    ...mapGetters(['selectedBot', 'currentLang']),
    checkMaxAnswer() {
      return this.answerinput.length >= 10
    }
  },
  created: function () {
    var vm = this
    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)
    if (this.type == 'edit') {
      var data = this.inputvalue
      this.id_question = data.id_question
      this.id_answer = data.id_answer
      this.id_comment = data.id_comment
      this.startDate = data.startDate
      this.startTime = data.startTime
      this.endDate = data.endDate
      this.endTime = data.endTime
      this.answerinput = data.answerinput
      this.question_messages = data.question_messages
      this.answer_messages = data.answer_messages
      this.tags = data.tags
      this.input.question = data.input.question
      this.tempname = `${data.input.question}`
    }
  },
  mounted() {},
  methods: {
    allowedDates(val) {
      if (this.startDate) {
        return moment(this.startDate).diff(val, 'days') < 1
      }
    },
    allowedDatesStart(val) {
      if (this.endDate) {
        return moment(this.endDate).diff(val, 'days') > 1
      }
    },
    allowedHours(val) {
      if (this.startDate && this.endDate) {
        var iscurrentDate = moment(this.startDate).isSame(this.endDate, 'day')
        if (iscurrentDate && this.startTime) {
          var parseTime = (timeString) => moment(timeString, 'HH:mm')
          var pastClosing = parseTime(val).isAfter(parseTime(this.startTime))

          return pastClosing
        } else {
          return true
        }
      }
    },
    saveData() {
      var vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          return false
        }
        if (!this.tags.length) {
          this.errorMessage = 'กรุณากรอก อย่างน้อย 1 คีย์เวิร์ด'
          return false
        } else if (!this.question_messages[0].length) {
          this.errorMessage = 'กรุณากรอก อย่างน้อย 1 คำถาม'
          return false
        } else if (!this.answer_messages[0].length) {
          this.errorMessage = 'กรุณากรอก อย่างน้อย 1 ข้อความตอบกลับ'
          return false
        }

        var data = [this.saveQuestion(), this.saveAnswer(), this.saveQuestionComment()]

        this.saveloading = true
        Promise.all(data).then(async () => {
          await this.$swal.fire({
            type: 'success',
            text: 'สำเร็จ'
          })
          this.saveloading = false

          this.$emit('dataChange')
          this.$emit('close')
        })
      })
    },
    addAnswerinput() {
      this.answerinput.push('')
    },
    onAddPrefill: function (payload) {
      this.normal.push({ text: payload })
    },
    onShowAdvance: function () {
      this.showAdvanced = !this.showAdvanced
    },
    checkTag: function (obj) {
      this.errorTag = []
      if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    getQuickReply() {
      // 97 == a
      return this.answerinput
        .map((el, k) => {
          return el
        })
        .join(',')
    },
    saveQuestion() {
      var data = {
        a_type: 'json',

        context_in: '*',
        context_out: '',
        exceptpostidlist: '',
        intentgroup: null,

        intentstatus: true,
        isShow: true,
        linenoti_status: false,
        linenoti_text: '',
        onlytime: false,
        pageid: this.selectedBot.pageid,
        postidlist: '',
        q_type: 'text',
        q_val: this.tags.map((el) => el.text).join(','),
        quick_reply: this.getQuickReply(),
        starttime: this.startDate + ' ' + this.startTime + ':00+07',
        endtime: this.endDate + ' ' + this.endTime + ':00+07',
        userstatus: this.userstatus,
        usertags: this.usertags
      }
      if (this.type == 'edit') {
        Object.assign(data, {
          id: this.id_question,
          intentname: 'Question__' + this.input.question,
          a_val: JSON.stringify([
            [
              // {
              //   text: `{checkagetopic(${this.input.question})}`,
              //   type: 'text',
              // },
              ...this.question_messages[0]
            ]
          ])
        })
      } else {
        Object.assign(data, {
          intentname: 'Question__' + `${moment().format('YYYYMMDD')}__` + this.input.question,
          a_val: JSON.stringify([
            [
              // {
              //   text: `{checkagetopic(${
              //     `${moment().format('YYYYMMDD')}__` + this.input.question
              //   })}`,
              //   type: 'text',
              // },
              ...this.question_messages[0]
            ]
          ])
        })
      }
      return new Promise((resolve) => {
        var apifunc = ''
        if (this.type == 'add') {
          apifunc = 'addIntent'
        } else if (this.type == 'edit') {
          apifunc = 'editIntent'
        }

        api[apifunc](data, (err, response) => {
          if (response.responsecode == 200) {
            resolve()
          } else resolve()
        })
      })
    },
    saveQuestionComment() {
      var data = {
        a_type: 'json',
        a_val: JSON.stringify([
          [
            {
              type: 'responsepost',
              replyinbox: true,
              replycomment: false,
              hidecomment: false,
              responseinbox: [
                {
                  text: 'สวัสดีค่ะคุณ{first_name} {last_name} สามารถร่วมเป็นส่วนหนึ่งกับรายการ "ถก..ไม่เถียง" ค่ะ กดปุ่มด้านล่างเพื่อดูคำถามสำหรับวันนี้ได้เลยค่ะ',
                  buttons: [
                    { title: this.tags[0].text, type: 'postback', payload: this.tags[0].text }
                  ],
                  type: 'button'
                }
              ],
              responsecomment: [{ type: 'text', text: '' }]
            }
          ]
        ]),
        context_in: 'comment',
        context_out: '',
        exceptpostidlist: '',
        intentgroup: null,
        intentstatus: true,
        isShow: true,
        linenoti_status: false,
        linenoti_text: null,
        onlytime: false,
        pageid: this.selectedBot.pageid,
        postidlist: '',
        q_type: 'text',
        q_val: this.tags.map((el) => el.text).join(','),
        quick_reply: this.getQuickReply(),
        starttime: this.startDate + ' ' + this.startTime + ':00+07',
        endtime: this.endDate + ' ' + this.endTime + ':00+07',
        userstatus: this.userstatus,
        usertags: this.usertags
      }

      if (this.type == 'edit') {
        Object.assign(data, {
          id: this.id_comment,
          intentname: 'Comment__' + this.input.question
        })
      } else {
        Object.assign(data, {
          intentname: 'Comment__' + `${moment().format('YYYYMMDD')}__` + this.input.question
        })
      }
      return new Promise((resolve) => {
        var apifunc = ''
        if (this.type == 'add') {
          apifunc = 'addIntent'
        } else if (this.type == 'edit') {
          apifunc = 'editIntent'
        }

        api[apifunc](data, (err, response) => {
          if (response.responsecode == 200) {
            resolve()
          } else resolve()
        })
      })
    },
    saveAnswer() {
      var data = {
        a_type: 'json',
        context_in: '',
        context_out: '',
        exceptpostidlist: '',
        intentgroup: null,

        intentstatus: true,
        isShow: true,
        linenoti_status: false,
        linenoti_text: '',
        onlytime: false,
        pageid: this.selectedBot.pageid,
        postidlist: '',
        q_type: 'text',
        q_val: this.getQuickReply(),
        quick_reply: '',
        starttime: this.startDate + ' ' + this.startTime + ':00+07',
        endtime: this.endDate + ' ' + this.endTime + ':00+07',
        userstatus: this.userstatus,
        usertags: this.usertags
      }
      if (this.type == 'edit') {
        Object.assign(data, {
          id: this.id_answer,
          intentname: 'Answer__' + this.input.question,
          a_val: JSON.stringify([
            [
              {
                text: `{saveanswertopic(${this.input.question},${
                  this.startDate + ' ' + this.startTime + ':00+07'
                },${this.endDate + ' ' + this.endTime + ':00+07'})}`,
                type: 'text'
              },
              ...this.answer_messages[0]
            ]
          ])
        })
      } else {
        Object.assign(data, {
          intentname: 'Answer__' + `${moment().format('YYYYMMDD')}__` + this.input.question,
          a_val: JSON.stringify([
            [
              {
                text: `{saveanswertopic(${
                  `${moment().format('YYYYMMDD')}__` + this.input.question
                },${this.startDate + ' ' + this.startTime + ':00+07'},${
                  this.endDate + ' ' + this.endTime + ':00+07'
                })}`,
                type: 'text'
              },
              ...this.answer_messages[0]
            ]
          ])
        })
      }
      return new Promise((resolve) => {
        var apifunc = ''
        if (this.type == 'add') {
          apifunc = 'addIntent'
        } else if (this.type == 'edit') {
          apifunc = 'editIntent'
        }
        api[apifunc](data, (err, response) => {
          if (response.responsecode == 200) {
            resolve()
          } else resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.titletero {
  font-weight: 600;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/tero/AddQuestion.vue